import React, { useState, useEffect } from "react";
import SubmittedAgendaItem from "../SubmittedAgendaItem";
import styles from "./SubmittedAgendaItemsPage.module.css";
import { useSubmittedAgenda } from "./useSubmittedAgenda";
import AddNewModal from "ManagementTeam/Shared/AddNewModal";
import { useAuth } from "shared/@auth";
import moment from "moment";
import ReactModal from "react-modal";
import { ReactComponent as DeleteIcon } from "../../assets/Delete_Icon.svg";
import Button from "shared/Button";
import formatDate from "shared/@utils/formatDate";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useLocation } from "react-router-dom";

export function SubmittedAgendaItemsPage({
  meetings,
  submittedAgendaItems,
  itemOwners,
  readOnly,
  users,
  submittedAgendaEditPut,
  submittedAgendaDelete,
  submittedAgendaMove,
  submittedAgendaOrder,
  submittedAgendaViewPut,
  refetchAgenda,
}) {
  const [_meetings, setMeetings] = useState(meetings);
  const [agendaItems, setAgendaItems] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingAgendaId, setEditingAgendaId] = useState(null);
  const [_meetingSelect, setMeetingSelect] = useState([]);
  const [meetingDateOptions, setMeetingDateOptions] = useState([]);
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [deleteAgendaId, setDeleteAgendaId] = useState("");
  const [movingAgendaId, setMovingAgendaId] = useState("");

  useEffect(() => {
    submittedAgendaItems &&
      submittedAgendaItems.length > 0 &&
      setAgendaItems(submittedAgendaItems.sort((a, b) => a.order - b.order));
  }, [submittedAgendaItems]);
  useEffect( () => {
    async function viewNewSubmitted() {
      await submittedAgendaViewPut.mutateAsync();
      // refetchAgenda();
    }
    viewNewSubmitted();
  }, []);
  const { account } = useAuth();

  const location = useLocation();

  const zeroPad = (num, places) => String(num).padStart(places, "0");
  // get meeting ids and dates
  useEffect(() => {
    const months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    var agendaSelect = [];
    meetings &&
      meetings.length > 0 &&
      meetings.map((meeting) => {
        // format options string
        var dateString = `${Object.keys(months).find((name) => {
          if (months[name] === meeting.dates[0].startsOn.substring(5, 7)) {
            return name;
          }
          return null;
        })}${meeting.dates.map((date, index) => {
          if (meeting.dates.length === 1) {
            return ` ${date.startsOn.substring(8, 10)}`;
          } else if (meeting.dates.length > 1) {
            if (
              index !== 0 &&
              meeting.dates[index - 1].startsOn.substring(8, 10) >
                meeting.dates[index].startsOn.substring(8, 10)
            ) {
              return ` ${Object.keys(months).find((name) => {
                if (
                  months[name] ===
                  `${zeroPad(
                    parseInt(meeting.dates[0].startsOn.substring(5, 7)) + 1,
                    2
                  )}`
                ) {
                  return name;
                }
                return null;
              })} ${date.startsOn.substring(8, 10)}`;
            } else {
              return ` ${date.startsOn.substring(8, 10)}`;
            }
          }
          return null;
        })} ${meeting.dates[0].startsOn.substring(0, 4)}`;

        var meetingDatesArray =
          meeting.dates.length > 0
            ? meeting.dates.map((date) =>
                moment.utc(date.startsOn).format("MMMM DD, YYYY")
              )
            : [];

        return agendaSelect.push({
          id: meeting._id,
          option: dateString,
          dates: meetingDatesArray,
        });
      });
    setMeetingSelect(agendaSelect);
  }, []);

  useEffect(() => {
    let meetingDates = [];
    _meetingSelect.map((select) => {
      meetingDates.push(select.option);
    });
    setMeetingDateOptions(meetingDates);
  }, [_meetingSelect]);

  const handleEdit = (data) => {
    setEditingAgendaId(data._id);
    const choices = data.decision
      ? data.decision.choices.map((choice) => choice.description)
      : [];

    const notes =
      (data.notes &&
        data.notes.map((note) => {
          return {
            ...note,
            content: note.note,
            author: (note.postedBy && note.postedBy.name) || "",
            date: note.submittedOn,
          };
        })) ||
      [];

    const itemInfo = {
      meetingDate: data.meetingDate,
      isSubmitted: true,
      itemOwner: data.owner,
      title: data.title,
      description: data.description,
      notes: [...notes],
      addTo: ["Agenda", choices.length > 0 ? "Decisions (Voting)" : null],
      votingRequirements: [],
      allowMultiple: data.decision?.maximumChoices > 1,
      maximumChoices: data.decision?.maximumChoices,
      selections: [...choices],
      document: data.document,
      documents: [],
    };
    if (data.decision) {
      if (data.decision.isBlockA) {
        itemInfo.votingRequirements.push('"A Block" Vote');
      }
      if (data.decision.isBlockB) {
        itemInfo.votingRequirements.push('"B Block" Vote');
      }
      if (data.decision.isMultipleChoice) {
        itemInfo.votingRequirements.push("Multiple Choice");
      }
    }
    setEditingItem(itemInfo);
    setShowEditModal(true);
  };

  const handleSaveEdit = (data) => {
    const agendaObject = {
      agendaId: editingAgendaId,
      documentId: data.documentId,
      filesToUpload: data.documents,
      isDocumentDownloadable: data.isDocumentDownloadable,
      owner: {
        _id: data.itemOwner.id,
        name: data.itemOwner.option,
        photoUrl: data.itemOwner.photoUrl,
      },
      title: data.title,
      description: data.description,
      notes:
        (data.notes &&
          data.notes.map((note) => {
            let postedBy = {
              name: note.author,
            };

            if (note.postedBy) {
              postedBy._id = note.postedBy._id;
            } else {
              let user =
                (users &&
                  users.find((user) => user.profile.email === note.username)) ||
                null;
              if (user) {
                postedBy._id = user._id;
              }
            }
            return {
              note: note.content,
              postedBy: postedBy,
              submittedOn: note.date,
              location: note.location,
            };
          })) ||
        [],
      decision: data.addTo.includes("Decisions (Voting)")
        ? {
            isMultipleChoice:
              data.votingRequirements.includes("Multiple Choice"),
            isBlockA: data.votingRequirements.includes('"A Block" Vote'),
            isBlockB: data.votingRequirements.includes('"B Block" Vote'),
            maximumChoices: data.allowMultiple ? data.maximumChoices : 1,
            choices: data.selections,
          }
        : null,
      status: "on",
      displayResults: false,
      isDraft: false,
    };

    submittedAgendaEditPut.mutate(agendaObject, {
      onSuccess: () => {
        refetchAgenda();
      },
    });

    let newAgendaItems = agendaItems;
    for (let index = 0; index < newAgendaItems.length; index++) {
      if (newAgendaItems[index]._id === editingAgendaId) {
        newAgendaItems[index] = agendaObject;
        break;
      }
    }

    setShowEditModal(false);
  };

  const handleDeleteAgenda = (selectedId) => {
    setAgendaItems(agendaItems.filter((item) => item.id !== selectedId));
    submittedAgendaDelete.mutate({
      agendaId: selectedId,
    });
    refetchAgenda();
  };

  const handleMoveSubmittedAgenda = (meetingDate, agendaId) => {
    submittedAgendaMove.mutate({
      agendaId: agendaId,
      moveToMeetingId: meetingDate.id,
    });
  };

  const handleDragEnd = (result) => {
    let items = [...agendaItems];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setAgendaItems(items);
    submittedAgendaOrder.mutate({
      agendaId: reorderedItem.id,
      meetingType: location.pathname.includes("management-team") ? "MT" : "EC",
      order: result.destination.index,
    });
  };

  return (
    <div className={styles.submittedAgendaItemContainer}>
      <ReactModal
        isOpen={deleteModelOpen}
        className={styles.deleteModal}
        overlayClassName={styles.overlay}
      >
        <div className={styles.deleteModalHeader}>
          <DeleteIcon />
          <p>
            Are you sure you want to delete this agenda item and any items
            associated with it?
          </p>
        </div>
        <div className={styles.deleteModalButtons}>
          <Button
            className={styles.cancelButton}
            children="Cancel"
            onClick={() => {
              setDeleteModelOpen(false);
            }}
          />
          <Button
            className={styles.deleteButton}
            children="Delete"
            onClick={() => {
              handleDeleteAgenda(deleteAgendaId);
              setDeleteModelOpen(false);
            }}
            purpose="delete"
          />
        </div>
      </ReactModal>
      {editingItem && (
        <AddNewModal
          isOpen={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setEditingItem(null);
          }}
          meetingDates={[] /*Use MOVE modal to move agenda*/}
          onSave={handleSaveEdit}
          onSaveDraft={() => alert("onSaveDraft")}
          currentUser={{ name: account.name, username: account.username }}
          itemInfo={{
            meetingDate: editingItem.meetingDate,
            itemOwner: editingItem.itemOwner,
            title: editingItem.title,
            description: editingItem.description,
            notes: editingItem.notes,
            addTo: editingItem.addTo,
            votingRequirements: editingItem.votingRequirements,
            allowMultiple: editingItem.allowMultiple,
            selections: editingItem.selections,
            document: editingItem.document,
            documents: [],
            isDocumentDownloadable: editingItem.isDocumentDownloadable,
          }}
          itemOwners={itemOwners}
        />
      )}
      {agendaItems && agendaItems.length > 0 && (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="submittedAgendaItems">
            {(provided) => (
              <div
                className={styles.dropArea}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {agendaItems.map((agenda, index) => (
                  <Draggable
                    key={agenda._id}
                    draggableId={agenda._id}
                    index={index}
                    isDragDisabled={agendaItems.length === 1}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          marginTop: "16px",
                          position: "relative",
                          height: "fit-content",
                          ...provided.draggableProps.style,
                        }}
                      >
                        <div
                          {...(provided.dragHandleProps && {
                            ...provided.dragHandleProps,
                          })}
                          style={{
                            position: "absolute",
                            left: "0",
                            width: "2.9%",
                            height: "100%",
                            display: "flex",
                            ...(provided.dragHandleProps && {
                              ...provided.dragHandleProps.style,
                            }),
                          }}
                        ></div>
                        <SubmittedAgendaItem
                          readOnly={readOnly}
                          assignee={agenda.owner.name}
                          assignedType={
                            agenda.owner.name
                              .toUpperCase()
                              .includes("PAUL TSIKA") ||
                            agenda.owner.name.includes("Attorneys")
                              ? "Attorney"
                              : agenda.owner.name.includes("WWG") ||
                                agenda.owner.name.includes("WWG Guest")
                              ? "WWG"
                              : "Diamond"
                          }
                          title={agenda.title}
                          description={agenda.description}
                          isNew={agenda.isNew}
                          onEdit={() => {
                            handleEdit(agenda);
                          }}
                          onDelete={() => {
                            setDeleteAgendaId(agenda.id);
                            setDeleteModelOpen(true);
                          }}
                          onAdd={(dateSelect) =>
                            handleMoveSubmittedAgenda(dateSelect, agenda)
                          }
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </div>
  );
}
